import Home from "../components/home/Home";
export default Home;
